(function () {
  var scrollY = 0;
  var locked = false;

  function lockBodyScroll() {
    if (locked) return;
    locked = true;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('tb-mm-scroll-locked');
    document.body.classList.add('tb-mm-scroll-locked');
  }

  function unlockBodyScroll() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('tb-mm-scroll-locked');
    document.body.classList.remove('tb-mm-scroll-locked');
    window.scrollTo(0, scrollY);
  }

  function syncScrollLock() {
    var menu = document.getElementById('site-menu-sidebar');
    var open =
      menu &&
      menu.classList.contains('tb-mobile-menu-drawer') &&
      menu.classList.contains('sidebar--opened');
    if (open) {
      lockBodyScroll();
      menu.querySelectorAll('.tb-mobile-menu').forEach(function (root) {
        setTimeout(function () {
          updateTabsScrollHint(root);
        }, 40);
      });
    } else if (!document.body.classList.contains('sidebar-opened')) {
      unlockBodyScroll();
    } else if (!document.body.classList.contains('sidebar-opened--left')) {
      unlockBodyScroll();
    }
  }

  function updateTabsScrollHint(root) {
    var wrap = root.querySelector('[data-tb-mm-tabs-wrap]');
    var tabsEl = root.querySelector('[data-tb-mm-tabs]');
    if (!wrap || !tabsEl) return;
    var max = tabsEl.scrollWidth - tabsEl.clientWidth;
    var left = tabsEl.scrollLeft;
    var hasOverflow = max > 2;
    wrap.classList.toggle('has-overflow', hasOverflow);
    wrap.classList.toggle('can-scroll-left', hasOverflow && left > 2);
    wrap.classList.toggle('can-scroll-right', hasOverflow && left < max - 2);
  }

  function initMobileMenu(root) {
    if (!root || root.dataset.tbMmReady === '1') return;
    root.dataset.tbMmReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tb-mm-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tb-mm-panel]'));
    var tabsEl = root.querySelector('[data-tb-mm-tabs]');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      if (tabs[index] && typeof tabs[index].scrollIntoView === 'function') {
        tabs[index].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
      updateTabsScrollHint(root);
    }

    if (tabsEl) {
      tabsEl.addEventListener(
        'scroll',
        function () {
          updateTabsScrollHint(root);
        },
        { passive: true }
      );
      window.addEventListener('resize', function () {
        updateTabsScrollHint(root);
      });
      setTimeout(function () {
        updateTabsScrollHint(root);
      }, 50);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index);
      });

      tab.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          next = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          next = 0;
        } else if (event.key === 'End') {
          next = tabs.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        activate(next);
        tabs[next].focus();
      });
    });
  }

  function watchMenuDrawer() {
    var menu = document.getElementById('site-menu-sidebar');
    if (!menu || menu.dataset.tbMmScrollWatch === '1') return;
    menu.dataset.tbMmScrollWatch = '1';

    new MutationObserver(syncScrollLock).observe(menu, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    document.getElementById('menu-open-button') &&
      document.getElementById('menu-open-button').addEventListener('click', function () {
        setTimeout(syncScrollLock, 20);
      });

    menu.querySelectorAll('.close-sidebar').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(syncScrollLock, 20);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.tb-mobile-menu').forEach(initMobileMenu);
    watchMenuDrawer();
    syncScrollLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('.tb-mobile-menu').forEach(initMobileMenu);
    watchMenuDrawer();
  });
})();
